module.exports = require("core-js/library/fn/number/parse-float");